import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MdbTableDirective, MdbTablePaginationComponent} from 'angular-bootstrap-md';
import { AllEventsService } from '../services/all-events.service';

export interface Events {
    eventid: string;
    eventname: string;
    organizer: string; 
    submissiondate: string;
    eventstartdate: string;
    country: string;
    url: string;
    status: string;
  }
   



@Component({
  selector: 'app-allevents',
  templateUrl: './allevents.component.html',
  styleUrls: ['./allevents.component.scss']
})
export class AlleventsComponent implements OnInit {

@ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;
  headElements = ['Event ID', 'Event Name', 'Organizer', 'Submission Date', 'Event Start Date', 'URL', 'Status'];
  searchText: string = '';
  previous: string;

  allEvents:any = [];

  sortForm:FormGroup;

  constructor(private cdRef: ChangeDetectorRef, 
    private EventsService: AllEventsService,
    private formBuilder:FormBuilder) {
  }

  @HostListener('input') oninput() {
      this.searchItems();
  }

  ngOnInit() {
    this.sortForm = this.formBuilder.group({
      sort:null
    })
      
      this.EventsService.getAllEvents().then((res:any) => {
        console.log(res);
        // this.allEvents=(res.events);
        for (let i = 0; i < res.events.data.length; i++) {
          this.allEvents.push({ 
            id: res.events.data[i].id, 
            event_name: res.events.data[i].event_name,
            organizer_name: res.events.data[i].organizer_name,
            created_at: res.events.data[i].event_dates[0].created_at,
            event_start_date: res.events.data[i].event_dates[0].date,
            country: res.events.data[i].country_list.countryname,
            website: res.events.data[i].website,
            status: res.events.data[i].status,

           });
        }
        this.mdbTable.setDataSource(this.allEvents);
      this.previous = this.mdbTable.getDataSource();
        //console.log(this.allEvents)
      }).catch((err) =>{
        console.log(err);
      }) 

  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
      const prev = this.mdbTable.getDataSource();
      if (!this.searchText) {
          this.mdbTable.setDataSource(this.previous);
          this.allEvents = this.mdbTable.getDataSource();
      }
      if (this.searchText) {
          this.allEvents = this.mdbTable.searchLocalDataBy(this.searchText);
          this.mdbTable.setDataSource(prev);
      }
  }



}
